/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import validate from 'validate.js';
import { Grid, TableCell } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';

import {
  DialogDefaultV2,
  DropzoneV2,
  TableWidgetV2,
  UsuarioSelectV2,
} from '../../../components/v2';

const schema = {
  usuarioId: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  file: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

/**
 * Lista local de usuário + arquivo (criação em lote de Holerite).
 */
const UsuarioContainer = ({
  usuarios,
  disabled,
  onSave,
  showError,
}) => {
  const [currentUsers, setCurrentUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectData, setSelectData] = useState(null);
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setCurrentUsers(usuarios ?? []);
  }, [usuarios]);

  useEffect(() => {
    if (selectData) {
      setValues(selectData);
    } else {
      setValues({});
    }
  }, [selectData]);

  const handleCloseNested = () => {
    setErrors({});
    setValues({});
    setOpen(false);
    setSelectData(null);
  };

  const handleCloseNestedWithUsers = (users) => {
    handleCloseNested();
    onSave(users ?? currentUsers);
  };

  const onAddLocal = () => {
    const errosLocal = validate(values, schema);
    setErrors(errosLocal || {});
    if (errosLocal && Object.keys(errosLocal).length > 0) {
      return;
    }
    const nextRow = {
      ...values,
      id: values.id || uuidv4(),
    };
    let nextUsers;

    const existedUsers = currentUsers.filter((p) => p.id === nextRow.id);
    if (existedUsers.length > 0) {
      nextUsers = currentUsers.map((p) =>
        p.id === nextRow.id ? nextRow : p
      );
    } else {
      nextUsers = [...currentUsers, nextRow];
    }

    setCurrentUsers(nextUsers);
    handleCloseNestedWithUsers(nextUsers);
  };

  const onDeleteLocal = (rowId) => {
    const nextUsers = currentUsers.filter((p) => p.id !== rowId);
    setCurrentUsers(nextUsers);
    onSave(nextUsers);
  };

  const onEditRow = (id) => {
    const row = currentUsers.find((p) => p.id === id);
    if (row) {
      setSelectData(row);
      setOpen(true);
    }
  };

  const renderRows = (p) => (
    <>
      <TableCell>{p.usuarioNome}</TableCell>
      <TableCell>{p.file?.alt || ''}</TableCell>
    </>
  );

  return (
    <>
      <Grid size={{ xs: 12 }} sx={{ pt: 0 }}>
        <TableWidgetV2
          rows={currentUsers}
          titles={['Usuário', 'Arquivo']}
          headerTitle="Usuários"
          deleteMessage="Tem certeza que deseja remover o usuário"
          renderRows={renderRows}
          hasRowActions
          onDelete={onDeleteLocal}
          onEdit={onEditRow}
          hasAdd={disabled !== true}
          showDelete={disabled !== true}
          showEdit={disabled !== true}
          showView={false}
          onAdd={() => {
            setSelectData(null);
            setOpen(true);
          }}
          showEmptyState={false}
          showError={showError}
        />
      </Grid>

      <DialogDefaultV2
        open={open}
        handlerCancel={handleCloseNested}
        handlerConfirm={onAddLocal}
        title={selectData ? 'Editar' : 'Novo'}
        confirmMessage="Adicionar"
        cancelMessage="Cancelar"
        maxWidth="sm"
        fullWidth
        useFullScreen={false}
      >
        <Grid container spacing={1} sx={{ mt: 0 }}>
          <Grid size={{ xs: 12 }} sx={{ pb: 0 }}>
            <UsuarioSelectV2
              label="Usuário"
              onSelect={(usuarioId, usuarioNome) =>
                setValues({ ...values, usuarioId, usuarioNome })}
              ativo
              value={values.usuarioId}
              isRequired
              error={!!(errors && errors.usuarioId)}
              multiSelect={false}
            />
          </Grid>
          <DropzoneV2
            buttonText="Arquivo"
            filesLimit={1}
            acceptedFiles={['.png', '.pdf', '.jpeg', '.jpg']}
            showGridFiles
            canDeleteFiles
            error={!!(errors && errors.file)}
            onSave={(files) => {
              if (files != null && files.length > 0) {
                const file = files[0];
                const fileOptions = {
                  id: uuidv4(),
                  nome: file.name.split('.')[0],
                  extensao: file.name.split('.').pop(),
                  alt: file.name,
                  file,
                  new: true,
                };
                setValues({ ...values, file: fileOptions });
              } else {
                setValues({ ...values, file: null });
              }
            }}
            files={
              values.file != null
                ? [
                  {
                    file: values.file.file,
                    nome: values.file.alt,
                    onDelete: () => setValues({ ...values, file: null }),
                  },
                ]
                : []
            }
          />
        </Grid>
      </DialogDefaultV2>
    </>
  );
};

UsuarioContainer.propTypes = {
  usuarios: PropTypes.array,
  disabled: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  showError: PropTypes.bool,
};

UsuarioContainer.defaultProps = {
  usuarios: [],
  disabled: undefined,
  showError: false,
};

export default UsuarioContainer;
